import { render, staticRenderFns } from "./descuentosLista.vue?vue&type=template&id=4675719c"
import script from "./descuentosLista.vue?vue&type=script&lang=js"
export * from "./descuentosLista.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports